'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = ['M48 112l0 38.8 208 143 208-143 0-38.8L48 112zm0 97l0 191 416 0 0-191L256 352 48 209z', 'M48 150.8l208 143 208-143 0-38.8L48 112l0 38.8zM464 209L256 352 48 209l0 191 416 0 0-191zM0 400L0 176l0-64L0 64l48 0 416 0 48 0 0 48 0 64 0 224 0 48-48 0L48 448 0 448l0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;